import { useMatches, useNavigate, useParams, useLocation } from 'react-router';

import {
  cleanFormIdParam,
  ID_PARAMS,
  IdParamsType,
} from 'common/src/routes/BaseRoutes';

import { NEW_ID } from 'portal/src/constants/ReservedIDs';

import EntityLoader from './EntityLoader';
import { FormComponentType } from './FormComponentType';

export default function BaseForm({
  apiPath,
  Component,
  idParamName = ID_PARAMS.ANY,
  allowAllOrgs = false,
  shouldNavigateBack = true,
}: {
  apiPath: string;
  Component: FormComponentType;
  idParamName?: IdParamsType;
  allowAllOrgs?: boolean;
  shouldNavigateBack?: boolean;
}) {
  const id = useParams()[cleanFormIdParam(idParamName)];
  const matches = useMatches();
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const navigateToParent = () => {
    // Reverse the matching routes so that we start looking for the current pathname from the start.
    // Ordinarily, the current path is the last item in the list
    const matchingRoutes = [...matches].reverse();

    // Navigate to the parent route by finding the current path in the matched routes list and selecting the next entry.
    // We match on the exact pathname to skip index routes, which react-router marks with a trailing `/`.
    const matchingRouteIdx = matchingRoutes.findIndex(
      (r) => r.pathname === pathname,
    );

    navigate(matchingRoutes.at(matchingRouteIdx + 1).pathname);
  };

  const handleBackAction = shouldNavigateBack ? navigateToParent : undefined;

  if (!Component) return <></>;

  return id !== NEW_ID ? (
    <EntityLoader
      apiPath={apiPath}
      Component={Component}
      handleBackAction={handleBackAction}
      id={id}
      allowAllOrgs={allowAllOrgs}
    />
  ) : (
    <Component handleBackAction={handleBackAction} />
  );
}
